import GraphqlBuilder from "utils/request/graphql/builder";
import MutationMessage from "graphql/mutations/MutationMessage";
import _ from "lodash";
import { constantsActive } from 'utils/constants/constants'
import FetchCachedMessage from 'utils/fetch/cached/FetchCachedMessage'
import MutationMessages from 'graphql/mutations/MutationMessages'

export default class MutateMessage {
	
	static archive = ( guid, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'message_archive', MutationMessage, {
				guid: guid,
				active: constantsActive.NO
			} )
			.setResultPath( ['message_archive', 'message'] , {} )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						message: result
					});
				}
				
				FetchCachedMessage.reload();
			})
			.execute()
	}
	
	static archiveAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'messages_archive_all', MutationMessages, {
				active: constantsActive.NO
			} )
			.setResultPath( ['messages_archive_all', 'messages'] , {} )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				
				//
				FetchCachedMessage.process( result )
				
				//
				FetchCachedMessage.reload();
				
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						message: result
					});
				}
			})
			.execute()
	}
	
	static setReadyBy = ( guids, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		const builder = new GraphqlBuilder()
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				
				FetchCachedMessage.reload();
				
				const messages = _.map( result, o => {
					return o.message;
				} )
				
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						messages: messages
					});
				}
			});

		_.forEach( guids, guid => {
			builder.addQuery( `message_is_read_${guid}`, MutationMessage, {
				guid: guid,
				is_read: constantsActive.YES
			})
		});
		
		builder.execute();
	}
	
	static readAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'messages_read_all', MutationMessages, {
				is_read: constantsActive.YES
			} )
			.setResultPath( ['messages_read_all', 'messages'] , {} )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				FetchCachedMessage.reload();
				
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						message: result
					});
				}
			})
			.execute()
	}
}
